export default "/images/6eaa7254e82163acbe2f9e68fdc9615f.png";